export default "__VITE_ASSET__W1eaevG6__"